import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule, MatMenuTrigger} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppInitService} from '../../service/app-init.service';
import {LanguageOption} from '../../model/language-option.model';
import {LanguageDialogComponent} from './language-dialog/language-dialog.component';
import {ProductLogoComponent} from '../product-logo/product-logo.component';

@Component({
  selector: 'app-patient-header',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatDialogModule,
    TranslateModule,
    ProductLogoComponent
  ],
  templateUrl: './patient-header.component.html',
  styleUrls: ['./patient-header.component.scss']
})
export class PatientHeaderComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  @Input() practiceName: string | null = 'Polya Terminservice';

  selectedLang = 'de';
  isMobile = false;

  @ViewChild(MatMenuTrigger) langMenuTrigger!: MatMenuTrigger;

  constructor(
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    public appInitService: AppInitService
  ) {}

  ngOnInit(): void {
    this.selectedLang = this.appInitService.currentLang;
    this.appInitService.currentLang$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.selectedLang = lang;
    });

    this.breakpointObserver.observe([Breakpoints.Handset])
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  changeLanguage(lang: LanguageOption) {
    this.selectedLang = lang.value;
    this.appInitService.setLanguage(lang.value);
  }

  handleLanguageClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isMobile) {
      this.dialog.open(LanguageDialogComponent, {
        width: '300px',
        data: {
          languages: this.appInitService.languageOptions,
          selectedLang: this.selectedLang
        }
      }).afterClosed().subscribe((result) => {
        if (result?.value) {
          this.changeLanguage(result);
        }
      });
    } else {
      this.langMenuTrigger.openMenu();
    }
  }

  onLanguageMenuClosed(): void {
    if (this.isMobile) return;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
